// removed by extract-text-webpack-plugin
module.exports = {"collection":"CZWxF","header":"_204Ic","title":"_3YyV1","published":"_3vJa8","description":"_1lnBz","marketingMessage":"Q-s45","itemsList":"ylxj8","loadMoreWrapper":"_1XLEE","loadMoreButton":"_27Pc7","addAllButton":"_1n0rW"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/CollectionDetail/index.sass
// module id = 1471
// module chunks = 1